/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import "../css/layout.scss"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <div className={"bg-grey-light min-h-screen"}>
        <div className={"container p-6 sm:p-8 md:p-12 lg:p-16 w-full"}>
          <main>{children}</main>
          <footer className={"text-center mt-10 text-xs md:text-sm lg:text-base"}>
            © Rick Booth {new Date().getFullYear()}, Built with
            {` `}
            <a className={"text-black hover:text-grey-darkest font-bold"} href="https://www.gatsbyjs.org">Gatsby</a>
          </footer>
        </div>
      </div>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
